import { TOTAL_STEPS } from "../GuidedOnboarding/tourSteps";

// Map a tour_summary status -> antd Tag color + label.
const STATUS_META = {
  not_started: { color: "default", text: "Not started" },
  in_progress: { color: "blue", text: "In progress" },
  completed: { color: "green", text: "Completed" },
  skipped: { color: "orange", text: "Skipped" },
  exited: { color: "gold", text: "Exited" },
};

// "How far" = furthest of (current_step+1) and seen_count, capped at the total.
// The total step count is FE-owned (tourSteps.js TOTAL_STEPS).
export function tourHowFar(t) {
  if (!t) return 0;
  const cur = typeof t.current_step === "number" ? t.current_step + 1 : 0;
  const seen = t.seen_count || 0;
  return Math.min(Math.max(cur, seen), TOTAL_STEPS);
}

export function tourTag(t) {
  const status = (t && t.status) || "not_started";
  const meta = STATUS_META[status] || STATUS_META.not_started;
  let text = meta.text;
  if (status === "in_progress" || status === "exited") {
    text += ` ${tourHowFar(t)}/${TOTAL_STEPS}`;
  }
  return { color: meta.color, text };
}

export { TOTAL_STEPS };
